<template>
  <ion-page>
    <ion-content class="white">
      <div v-if="[0, 1].includes(progress_step)">
        <ion-header style="font-weight: bold" class="ion-margin-bottom ion-margin-top ion-text-center">
          会員登録
        </ion-header>
        <div class="logo-circle ion-text-center" style="margin: 0 auto;">P</div>
        <ion-header style="font-weight: bold; color: var(--ion-color-primary)"
                    class="ion-margin-bottom ion-margin-top ion-text-center">ポイントがたまる・使える
        </ion-header>
      </div>

      <form v-if="progress_step == 0">
        <div class="ion-margin-start ion-margin-end">
          <ion-grid>
            <ion-header style="font-weight: bold" class="ion-margin-bottom ion-margin-top">お客様情報
            </ion-header>

            <RequiredInput label="姓" :required="false"/>
            <ion-row>
              <ion-col size="12">
                <ion-input class="required-input" v-model="last_name" helper-text="例）山田"></ion-input>
                <ion-text color="danger" v-if="errors && errors.last_name">{{
                    errors.last_name
                  }}
                </ion-text>
              </ion-col>
            </ion-row>

            <RequiredInput label="名" :required="false"/>
            <ion-row>
              <ion-col size="12">
                <ion-input class="required-input" v-model="first_name"
                           helper-text="例）太郎"></ion-input>
                <ion-text color="danger" v-if="errors && errors.first_name">{{
                    errors.first_name
                  }}
                </ion-text>
              </ion-col>
            </ion-row>

            <RequiredInput label="姓（カナ）" :required="false"/>
            <ion-row>
              <ion-col size="12">
                <ion-input class="required-input" v-model="last_name_kana"
                           helper-text="例）ヤマダ"></ion-input>
                <ion-text color="danger" v-if="errors && errors.last_name_kana">{{
                    errors.last_name_kana
                  }}
                </ion-text>
              </ion-col>
            </ion-row>

            <RequiredInput label="名（カナ）" :required="false"/>
            <ion-row>
              <ion-col size="12">
                <ion-input class="required-input" v-model="first_name_kana"
                           helper-text="例）タロウ"></ion-input>
                <ion-text color="danger" v-if="errors && errors.first_name_kana">
                  {{ errors.first_name_kana }}
                </ion-text>
              </ion-col>
            </ion-row>

            <RequiredInput label="郵便番号"/>
            <ion-row>
              <ion-col size="6">
                <ion-input class="required-input" v-model="postal_code"
                           helper-text="例）1000000"></ion-input>
                <ion-text color="danger" v-if="errors && errors.postal_code">{{
                    errors.postal_code
                  }}
                </ion-text>
              </ion-col>
              <ion-col size="6" class="ion-no-padding">
                <ion-button color="dark" @click="getPostalCode" expand="block">住所の自動入力</ion-button>
              </ion-col>
            </ion-row>

            <RequiredInput label="都道府県" :required="false"/>
            <ion-row>
              <ion-col size="12">
                <ion-item class="required-input">
                  <ion-select placeholder="都道府県" v-model="prefecture_id">
                    <ion-select-option :key="prefecture.id" v-for="prefecture of allPrefectures"
                                       :value="prefecture.id">{{ prefecture.name }}
                    </ion-select-option>
                  </ion-select>
                </ion-item>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <ion-text color="danger" v-if="errors && errors.prefecture">{{
                    errors.prefecture
                  }}
                </ion-text>
              </ion-col>
            </ion-row>

            <RequiredInput label="市区町村・番地" :required="false"/>
            <ion-row>
              <ion-col size="12">
                <ion-input class="required-input" v-model="address"></ion-input>
                <ion-text color="danger" v-if="errors && errors.address">{{ errors.address }}</ion-text>
              </ion-col>
            </ion-row>

            <RequiredInput label="建物名・部屋番号" :required="false"/>
            <ion-row>
              <ion-col size="12">
                <ion-input class="required-input" v-model="building_room"
                           helper-text="例）◯◯マンション101"></ion-input>
                <ion-text color="danger" v-if="errors && errors.building_room">{{
                    errors.building_room
                  }}
                </ion-text>
              </ion-col>
            </ion-row>

            <RequiredInput label="電話番号"/>
            <ion-row>
              <ion-col size="12">
                <ion-input class="required-input" v-model="phone_number"
                           :validate="checkSingleByteNumbers" helper-text="例）0311112222"></ion-input>
                <ion-text color="danger" v-if="errors && errors.phone_number">{{
                    errors.phone_number
                  }}
                </ion-text>
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col>
                <ion-label style="font-weight: 900">メールアドレス</ion-label>
              </ion-col>
              <ion-col size="12">
                <ion-input class="required-input" :disabled="true" v-model="email"></ion-input>
                <ion-text color="danger" v-if="errors && errors.email">{{ errors.email }}</ion-text>
              </ion-col>
            </ion-row>
            <RequiredInput label="パスワード"/>
            <ion-row>
              <ion-col size="12">
                <ion-input :type="show_password ? 'text' : 'password'" class="required-input"
                           v-model="password" :validate="checkSingleByteNumbers"
                           helper-text="パスワードは半角8〜20文字、英字・数字混在で入力してください">
                  <ion-button slot="end" size="small" @click="show_password = !show_password">
                    <ion-icon slot="icon-only" color="black" :icon="eye"></ion-icon>
                  </ion-button>
                </ion-input>
                <ion-text color="danger" v-if="errors && errors.password">{{ errors.password }}</ion-text>
              </ion-col>
            </ion-row>
            <RequiredInput class="ion-margin-top" label="パスワード（確認用）"/>
            <ion-row>
              <ion-col size="12">
                <ion-input :type="show_confirm_password ? 'text' : 'password'" class="required-input"
                           v-model="password_confirmation"
                           helper-text="パスワードは半角8〜20文字、英字・数字混在で入力してください">
                  <ion-button slot="end" size="small"
                              @click="show_confirm_password = !show_confirm_password">
                    <ion-icon slot="icon-only" color="black" :icon="eye"></ion-icon>
                  </ion-button>
                </ion-input>
                <ion-text color="danger" v-if="errors && errors.password_confirmation">{{ errors.password_confirmation }}</ion-text>
              </ion-col>
            </ion-row>
            <RequiredInput label="性別"/>
            <ion-row>
              <ion-col size="auto">
                <ion-radio-group v-model="gender">
                  <ion-radio label-placement="end" :value="1">男性</ion-radio>
                  <ion-radio label-placement="end" :value="2">女性</ion-radio>
                  <ion-radio label-placement="end" :value="3">登録しない</ion-radio>
                </ion-radio-group>
                <ion-text color="danger" v-if="errors && errors.gender">{{ errors.gender }}</ion-text>
              </ion-col>
            </ion-row>
            <RequiredInput label="生年月"/>
            <ion-row>
              <ion-col size="auto">
                <ion-item class="required-input">
                  <ion-select v-model="birth_year" placeholder="年">
                    <ion-select-option :key="year" v-for="year in years" :value="year">{{
                        year
                      }}
                    </ion-select-option>
                  </ion-select>
                </ion-item>
              </ion-col>
              <ion-col size="auto">
                <ion-item class="required-input">
                  <ion-select v-model="birth_month" placeholder="月">
                    <ion-select-option :key="month" v-for="month in months" :value="month">{{
                        month
                      }}
                    </ion-select-option>
                  </ion-select>
                </ion-item>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col size="12">
                <ion-text color="danger" v-if="errors && errors.birth_date">{{ errors.birth_date }}</ion-text>
              </ion-col>
              <ion-col size="12">
                <ion-text color="danger" v-if="errors && errors.birth_year">{{ errors.birth_year }}</ion-text>
              </ion-col>
              <ion-col size="12">
                <ion-text color="danger" v-if="errors && errors.birth_month">{{ errors.birth_month }}</ion-text>
              </ion-col>
            </ion-row>

            <RequiredInput label="ご職業" :required="false"/>
            <ion-row>
              <ion-col size="12">
                <ion-item class="required-input">
                  <ion-select v-model="occupation">
                    <ion-select-option :key="index" v-for="(occupation, index) of occupations"
                                       :value="occupation.value">{{ occupation.label }}
                    </ion-select-option>
                  </ion-select>
                </ion-item>
              </ion-col>
            </ion-row>

            <RequiredInput label="お気に入り店舗"/>
            <ion-row>
              <ion-col size="12">
                <ion-radio-group v-model="store_search_type">
                  <ion-radio label-placement="end" :value="1">店舗の種類から検索</ion-radio>
                  <ion-radio label-placement="end" :value="2">店舗コードから検索</ion-radio>
                </ion-radio-group>
              </ion-col>
            </ion-row>
            <div v-if="store_search_type == 1">
              <ion-row>
                <ion-col size="12">
                  <ion-item class="required-input">
                    <ion-select @ionChange="fetchPrefectures()" placeholder="店舗の種類"
                                v-model="selected_brand">
                      <ion-select-option :key="brand.name" v-for="brand of brands" :value="brand">
                        {{ brand.name }}
                      </ion-select-option>
                    </ion-select>
                  </ion-item>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col size="12">
                  <ion-item class="required-input">
                    <ion-select @ionChange="fetchStores()" placeholder="都道府県"
                                v-model="selected_prefecture">
                      <ion-select-option :key="prefecture" v-for="prefecture of prefectures"
                                         :value="prefecture">{{ prefecture.name }}
                      </ion-select-option>
                    </ion-select>
                  </ion-item>
                </ion-col>
              </ion-row>
              <ion-row>
                <ion-col size="12">
                  <ion-item class="required-input">
                    <ion-select placeholder="店舗名" v-model="selected_store">
                      <ion-select-option :key="store.id" v-for="store of stores" :value="store">
                        {{ store.name }}
                      </ion-select-option>
                    </ion-select>
                  </ion-item>
                </ion-col>
              </ion-row>
            </div>
            <div v-if="store_search_type == 2">
              <ion-row>
                <ion-col size="9">
                  <ion-input class="required-input" style="height: 100%" v-model="store_code"
                             placeholder="店舗コード"></ion-input>
                </ion-col>
                <ion-col size="3">
                  <ion-button class="primary-button" @click="searchStore" expand="block">検索 >
                  </ion-button>
                </ion-col>
                <ion-col size="12" v-if="show_store_error">
                  <ion-text color="danger">店舗が見つかりませんでした。</ion-text>
                </ion-col>
                <ion-col size="12">
                  <ion-text>{{ selected_brand?.name ?? '' }}</ion-text>
                </ion-col>
                <ion-col size="12">
                  <ion-text>{{ selected_prefecture?.name ?? '' }}</ion-text>
                </ion-col>
                <ion-col size="12">
                  <ion-text>{{ selected_store?.name ?? '' }}</ion-text>
                </ion-col>
              </ion-row>
            </div>
            <ion-text color="danger" v-if="errors && errors.store_id">{{ errors.store_id }}</ion-text>
            <ion-row>
              <ion-col>
                <ion-button class="ion-margin-top primary-button" @click="progress_step = 1"
                            expand="block">入力内容の確認へ進む >
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>
      </form>
      <div class="ion-padding-horizontal" v-else-if="progress_step == 1">
        <ion-grid>
          <ion-text>ご入力内容に誤りがないかご確認ください。よろしければ「登録」ボタンを押してください。
          </ion-text>
          <ion-header style="font-weight: bold" class="ion-margin-bottom ion-margin-top">お客様情報
          </ion-header>
          <ion-row>
            <ion-col size="5">
              <ion-text>姓：</ion-text>
            </ion-col>
            <ion-col size="7">
              <ion-text>{{ last_name }}</ion-text>
            </ion-col>
            <ion-col size="5">
              <ion-text>名：</ion-text>
            </ion-col>
            <ion-col size="7">
              <ion-text>{{ first_name }}</ion-text>
            </ion-col>
            <ion-col size="5">
              <ion-text>姓（カナ）：</ion-text>
            </ion-col>
            <ion-col size="7">
              <ion-text>{{ last_name_kana }}</ion-text>
            </ion-col>
            <ion-col size="5">
              <ion-text>名（カナ）：</ion-text>
            </ion-col>
            <ion-col size="7">
              <ion-text>{{ first_name_kana }}</ion-text>
            </ion-col>
            <ion-col size="5">
              <ion-text>郵便番号：</ion-text>
            </ion-col>
            <ion-col size="7">
              <ion-text>{{ postal_code }}</ion-text>
            </ion-col>
            <ion-col size="5">
              <ion-text>都道府県：</ion-text>
            </ion-col>
            <ion-col size="7">
              <ion-text>{{
                  allPrefectures.find((prefecture: Prefecture) => prefecture.id == prefecture_id)?.name ?? ''
                }}
              </ion-text>
            </ion-col>
            <ion-col size="5">
              <ion-text>市区町村・番地：</ion-text>
            </ion-col>
            <ion-col size="7">
              <ion-text>{{ address }}</ion-text>
            </ion-col>
            <ion-col size="5">
              <ion-text>建物名・部屋番号：</ion-text>
            </ion-col>
            <ion-col size="7">
              <ion-text>{{ building_room }}</ion-text>
            </ion-col>
            <ion-col size="5">
              <ion-text>電話番号：</ion-text>
            </ion-col>
            <ion-col size="7">
              <ion-text>{{ phone_number }}</ion-text>
            </ion-col>
            <ion-col size="5">
              <ion-text>メールアドレス：</ion-text>
            </ion-col>
            <ion-col size="7">
              <ion-text>{{ email }}</ion-text>
            </ion-col>
            <ion-col size="5">
              <ion-text>パスワード：</ion-text>
            </ion-col>
            <ion-col size="7">
              <ion-text>************</ion-text>
            </ion-col>
            <ion-col size="5">
              <ion-text>性別：</ion-text>
            </ion-col>
            <ion-col size="7">
              <ion-text>{{ gender == '1' ? '男性' : gender == '2' ? '女性' : '登録しない' }}</ion-text>
            </ion-col>
            <ion-col size="5">
              <ion-text>生年月：</ion-text>
            </ion-col>
            <ion-col size="7">
              <ion-text>{{ birth_year }}年{{ birth_month }}月</ion-text>
            </ion-col>
            <ion-col size="5">
              <ion-text>職業：</ion-text>
            </ion-col>
            <ion-col size="7">
              <ion-text>{{ occupation }}</ion-text>
            </ion-col>
            <ion-col size="5">
              <ion-text>お気に入り店舗：</ion-text>
            </ion-col>
            <ion-col size="7">
              <ion-text>{{ selected_brand?.name ?? '' }}</ion-text>
              <br/>
              <ion-text>{{ selected_prefecture?.name ?? '' }}</ion-text>
              <br/>
              <ion-text>{{ selected_store?.name ?? '' }}</ion-text>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col>
              <ion-button class="ion-margin-top primary-button" @click="validateForm" expand="block">登録
                >
              </ion-button>
              <ion-button class="ion-margin-top secondary-button" expand="block" fill="outline"
                          @click="progress_step = 0">戻る >
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
      <div v-else-if="progress_step == 2">
        <ion-header style="font-weight: bold; font-size: 22px" class="ion-margin-vertical ion-text-center">
          会員登録ありがとうございます！
        </ion-header>
        <div class="ion-text-center">
          <img alt='' :src="registerCompleteIcon"/>
        </div>
        <ion-button class="ion-margin-top primary-button" style="font-size: 20px" expand="block"
                    @click="goToCouponTab()">クーポンをチェックする
        </ion-button>
        <p class="ion-text-center ion-margin-top" style="color: black; font-weight: bold;">
          入会特典クーポンをプレゼント！<br/>
          クーポン一覧よりご確認ください！
        </p>
      </div>
    </ion-content>
  </ion-page>
</template>

<script setup lang="ts">
import {
  IonButton,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonIcon,
  IonInput,
  IonPage,
  IonRadio,
  IonRadioGroup,
  IonRow,
  IonSelect,
  IonSelectOption,
  IonText,
  loadingController,
  LoadingOptions,
  onIonViewWillEnter,
} from "@ionic/vue";
import {eye} from 'ionicons/icons'
import registerCompleteIcon from '@/assets/chiyoda_icon/register_complete.png'
import {onMounted, ref, watch} from "vue";
import request from '@/utils/Request'
import {useField, useForm, useFormErrors} from 'vee-validate';
import * as yup from 'yup';
import {KATAKANA_PATTERN, KATAKANA_ERROR_MESSAGE} from "@/consts/validation";
import RequiredInput from "@/components/RequiredInput.vue";
import {useRoute} from "vue-router";
import {getBrands, getPrefectures, getStoreByCode, getStores} from "@/actions/favorite-store";
import {trackPageView} from '@/utils/ga';
import {goToCouponTab} from "@/helpers/platform";
import {datadogLogs} from "@datadog/browser-logs";
import {listAllPrefectures, Prefecture} from "@/actions/list-prefectures";
import {occupations} from "@/consts/enums";
import {getAddressFromPostalCode, PostalData} from "@/helpers/kenall";
import { alertController } from '@ionic/vue'
import stringWidth from "string-width";

const route = useRoute();

const currentYear = new Date().getFullYear();
const startYear = 1900;
const years = Array.from({ length: currentYear - startYear + 1 }, (_, index) => currentYear - index);

const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

onIonViewWillEnter(async () => {
  await fetchBrands();
})

const schema = yup.object({
  last_name: yup.string()
      .nullable()
      .test(
          'max-width',
          `姓は全角15文字以内で入力してください`,
          (value) => !value || stringWidth(value) <= 30
      ),
  first_name: yup.string()
      .nullable()
      .test(
          'max-width',
          `名は全角15文字以内で入力してください`,
          (value) => !value || stringWidth(value) <= 30
      ),
  first_name_kana: yup.string()
      .nullable()
      .test(
          'max-width',
          `名（カナ）は全角15文字以内で入力してください`,
          (value) => !value || stringWidth(value) <= 30
      )
      .test('katakana', `名（カナ）は${KATAKANA_ERROR_MESSAGE}`, function(value) {
        if (!value || value === '') return true; // nullable のため空文字は許可
        return KATAKANA_PATTERN.test(value);
      }),
  last_name_kana: yup.string()
      .nullable()
      .test(
          'max-width',
          `姓（カナ）は全角15文字以内で入力してください`,
          (value) => !value || stringWidth(value) <= 30
      )
      .test('katakana', `姓（カナ）は${KATAKANA_ERROR_MESSAGE}`, function(value) {
        if (!value || value === '') return true; // nullable のため空文字は許可
        return KATAKANA_PATTERN.test(value);
      }),
  prefecture_id: yup.number()
      .nullable(),
  address: yup.string()
      .nullable()
      .test(
          'max-width',
          `市区町村・番地は全角100文字以内で入力してください`,
          (value) => !value || stringWidth(value) <= 200
      ),
  building_room: yup.string()
      .nullable()
      .test(
          'max-width',
          `建物名・部屋番号は全角100文字以内で入力してください`,
          (value) => !value || stringWidth(value) <= 200
      ),
  occupation: yup.string()
      .nullable(),
  gender: yup.string().required('性別をご入力ください').test('Empty', '性別が正しくありません', code => !code || /^[1-3]+$/.test(code)),
  postal_code: yup.string().required('居住地郵便番号をご入力ください').test('Empty', '居住地郵便番号が正しくありません', code => !code || /^\d{7}$/.test(code)),
  birth_month: yup.string().required('生年月（月）は必ず指定してください'),
  birth_year: yup.string().required('生年月（年）は必ず指定してください'),
  store_id: yup.string().required('お気に入り店舗を必ず指定してください'),
  phone_number: yup.string()
      .required('電話番号をご入力ください')
      .matches(/^[0-9]{10,30}$/, '電話番号は10〜30桁でご入力ください'),
  password: yup.string()
      .required('パスワードをご入力ください')
      .matches(/^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{8,20}$/, 'パスワードは半角英数8〜20文字でご入力ください'),
  password_confirmation: yup.string()
      .required('確認用パスワードをご入力ください')
      .matches(/^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{8,20}$/, '確認用パスワードは半角英数8〜20文字でご入力ください'),
}).test('birth_date', '生年月を完全に入力してください', function(value) {
  const { birth_year, birth_month } = value;
  if ((birth_year && !birth_month) || (!birth_year && birth_month)) {
    return this.createError({
      path: 'birth_date', // エラー表示の対象とするフィールド
      message: '生年月を完全に入力してください',
    });
  }

  if (birth_year && birth_month) {
    const birthDate = Date.parse(`${birth_year}-${birth_month}-01`);
    const currentDate = Date.now();

    if (birthDate > currentDate) {
      return this.createError({
        path: 'birth_date',
        message: '生年月は未来の年月を指定出来ません',
      });
    }
  }

  return true;
})

async function getPostalCode() {
  if (/^\d{7}$/.test(postal_code.value)) {
    const postalData: PostalData[] = await getAddressFromPostalCode(postal_code.value);
    if (postalData.length > 1) {
      const inputs = postalData.map((item: PostalData) => ({
        name: item.town,
        type: 'radio' as const,
        label: (item.prefecture ?? '') + (item.city ?? '') + (item.town ?? '') + (item.koaza ?? ''),
        value: item
      }));
      const selectPrefectureAlert = await alertController.create({
        header: '住所を選んでください',
        inputs: inputs,
        buttons: [
          { text: 'Cancel', role: 'cancel' },
          {
            text: 'OK',
            handler: (selectedItem) => {
              setSelectedPrefecture(selectedItem);
            }
          }
        ]
      })
      await selectPrefectureAlert.present();
    }
    else if (postalData.length === 1) {
      setSelectedPrefecture(postalData[0])
    }
  }
}

function setSelectedPrefecture(selectedPrefecture: PostalData) {
  const prefecture = allPrefectures.value.find((item: Prefecture) => item.name == selectedPrefecture.prefecture);
  if (prefecture) {
    prefecture_id.value = prefecture.id;
  }
  address.value = (selectedPrefecture.city ?? '') + (selectedPrefecture.town ?? '') + (selectedPrefecture.koaza ?? '');
}

const formFormalRegister = useForm({
  validationSchema: schema,
  initialValues: {
    occupation: '',
    store_id: null
  }
})

const { setFieldError } = formFormalRegister

onMounted(async () => {
  email.value = route.query.email ?? '';
  const prefectureResponse: any = await listAllPrefectures();
  if (!prefectureResponse.status) {
    return
  }
  allPrefectures.value = prefectureResponse.data?.prefectures ?? [];
});

const allPrefectures = ref<any>([]);
const { value: phone_number } = useField<string>("phone_number")
const { value: password } = useField<string>("password")
const { value: password_confirmation } = useField<string>("password_confirmation")
const { value: postal_code } = useField<string>('postal_code')
const { value: gender } = useField<string>('gender');
const { value: birth_year } = useField<number>('birth_year');
const { value: birth_month } = useField<number>('birth_month');
const { value: email } = useField<any>('email');
const { value: store_id } = useField<any>('store_id');
const { value: last_name } = useField<string>('last_name')
const { value: first_name } = useField<string>('first_name')
const { value: last_name_kana } = useField<string>('last_name_kana')
const { value: first_name_kana } = useField<string>('first_name_kana')
const { value: prefecture_id } = useField<any>('prefecture_id');
const { value: address } = useField<any>('address');
const { value: building_room } = useField<any>('building_room');
const { value: occupation } = useField<string>('occupation');

const store_search_type = ref(1);
const store_code = ref('');
const selected_brand = ref<any>('');
const selected_prefecture = ref<any>('');
const selected_store = ref<any>('');
const show_store_error = ref(false);
const show_password = ref(false);
const show_confirm_password = ref(false);
const progress_step = ref(0);
const errors = useFormErrors();

watch(progress_step, (newVal) => {
  if (newVal === 1) {
    trackPageView('/registration/user-info-confirm', '会員登録_入力確認');
  }
});

async function fetchBrands() {
  const brandResponse = await getBrands();
  if (!brandResponse.status) {
    return
  }
  brands.value = brandResponse.data.brands
}

async function fetchPrefectures() {
  selected_prefecture.value = null;
  selected_store.value = null;
  stores.value = [];
  if(selected_brand.value) {
    const prefectureResponse: any = await getPrefectures(selected_brand.value.id);
    if (!prefectureResponse.status) {
      return
    }
    prefectures.value = prefectureResponse.data?.prefectures ?? [];
  }
}

async function fetchStores() {
  if (selected_store.value) {
    selected_store.value = null;
  }
  if (selected_prefecture.value && selected_brand.value) {
    const storesResponse: any = await getStores(selected_brand.value.id, selected_prefecture.value.id);
    if (!storesResponse.status) {
      return
    }
    stores.value = storesResponse.data?.stores ?? [];
  }
}

async function searchStore() {
  show_store_error.value = false;

  // 店舗コード未入力チェック
  if (!store_code.value || store_code.value.trim() === '') {
    setFieldError('store_id', 'お気に入り店舗を必ず指定してください');
    selected_brand.value = null;
    selected_prefecture.value = null;
    selected_store.value = null;
    return;
  }

  const storeResponse: any = await getStoreByCode(store_code.value);
  if (storeResponse.data.store) {
    const foundStore = storeResponse.data.store;
    selected_brand.value = foundStore.brand;
    await fetchPrefectures();
    selected_prefecture.value = foundStore.prefecture;
    await fetchStores();
    selected_store.value = foundStore
  } else {
    show_store_error.value = true;
    selected_brand.value = null;
    selected_prefecture.value = null;
    selected_store.value = null;
  }
}

watch([() => store_search_type.value], async () => {
  selected_brand.value = null;
  selected_prefecture.value = null;
  if (selected_store.value) {
    selected_store.value = null;
  }
})
watch([() => selected_store.value], async () => {
  store_id.value = selected_store.value?.id ?? null;
})

async function createLoading(msg: string, duration?: number, spinner: LoadingOptions["spinner"] = "crescent") {
  return await loadingController.create({
    message: msg,
    duration: duration,
    spinner: spinner,
  })
}

async function validateForm() {
  const formValidity = await formFormalRegister.validate();
  const loading = await createLoading('登録中です...')
  if (formValidity.valid) {
    await loading.present()
    try {
      const data = {
        gender: gender.value,
        email: email.value,
        password: password.value,
        password_confirmation: password_confirmation.value,
        birth_year: birth_year.value,
        birth_month: birth_month.value,
        postal_code: postal_code.value,
        phone_number: phone_number.value,
        store_id: selected_store.value?.id ?? null,
        last_name: last_name.value,
        first_name: first_name.value,
        last_name_kana: last_name_kana.value,
        first_name_kana: first_name_kana.value,
        prefecture_id: prefecture_id.value,
        address: address.value,
        building_room: building_room.value,
        occupation: occupation.value
      }
      await request.post('/register-profile', data);
      progress_step.value = 2;
      trackPageView('/registration/complete', '会員登録完了');
    } catch (error: any) {
      if (!error.response) {
        datadogLogs.logger.error(error);
      } else if (error.response.status == 422) {
        progress_step.value = 0;
        formFormalRegister.setErrors(error.response.data.errors);
      }
    } finally {
      await loading.dismiss();
    }
  } else {
    progress_step.value = 0;
  }
}

const brands = ref<any>([]);
const prefectures = ref<any>([]);
const stores = ref<any>([]);

function checkSingleByteNumbers(event: Event): boolean {
  const re = /^[0-9]+$/g
  const target = event.target as HTMLInputElement
  return re.test(target.value)
}

</script>

<style scoped lang="scss">
.required-input {
  --background: #EFEFEF;
}

ion-input {
  --padding-start: 10px;
}
</style>